export const demoShippingAddresses = [{
    "beShippingAddressId": 1,
    "shippingAddressName": "Demo 1",
    "shippingAddress1": "75 W Center St",
    "shippingAddress2": "",
    "shippingAddress3": "",
    "shippingCity": "Provo",
    "shippingCounty": "",
    "shippingState": "UT",
    "shippingPostalCode": "84601-4432",
    "shippingCountry": "US",
    "shippingPhone": "8888888888",
    "shippingMobilePhone": "",
    "shippingInstructions": "",
    "shippingAlias": "010721113013",
    "addressType": "home",
    "shippingEmail": "my@home.com",
    "defaultShipping": false
},{
    "beShippingAddressId": 2,
    "shippingAddressName": "Demo 2",
    "shippingAddress1": "76 W Center St",
    "shippingAddress2": "HR04",
    "shippingAddress3": "",
    "shippingCity": "Provo",
    "shippingCounty": "Utah",
    "shippingState": "UT",
    "shippingPostalCode": "84601-4432",
    "shippingCountry": "US",
    "shippingPhone": "8888888888",
    "shippingMobilePhone": "",
    "shippingInstructions": "",
    "shippingAlias": "010721113013",
    "addressType": "home",
    "shippingEmail": "my@home.com",
    "defaultShipping": false
},{
    "beShippingAddressId": 3,
    "shippingAddressName": "Demo 3",
    "shippingAddress1": "75 W Center St",
    "shippingAddress2": "",
    "shippingAddress3": "",
    "shippingCity": "Provo",
    "shippingCounty": "",
    "shippingState": "UT",
    "shippingPostalCode": "84601-4432",
    "shippingCountry": "US",
    "shippingPhone": "8888888888",
    "shippingMobilePhone": "",
    "shippingInstructions": "",
    "shippingAlias": "010721113013",
    "addressType": "home",
    "shippingEmail": "my@home.com",
    "defaultShipping": false
},{
    "beShippingAddressId": 4,
    "shippingAddressName": "Demo 4",
    "shippingAddress1": "75 W Center St",
    "shippingAddress2": "",
    "shippingAddress3": "",
    "shippingCity": "Provo",
    "shippingCounty": "",
    "shippingState": "UT",
    "shippingPostalCode": "84601-4432",
    "shippingCountry": "US",
    "shippingPhone": "8888888888",
    "shippingMobilePhone": "",
    "shippingInstructions": "",
    "shippingAlias": "010721113013",
    "addressType": "home",
    "shippingEmail": "my@home.com",
    "defaultShipping": false
},{
    "beShippingAddressId": 5,
    "shippingAddressName": "Demo 5",
    "shippingAddress1": "75 W Center St",
    "shippingAddress2": "",
    "shippingAddress3": "",
    "shippingCity": "Provo",
    "shippingCounty": "",
    "shippingState": "UT",
    "shippingPostalCode": "84601-4432",
    "shippingCountry": "US",
    "shippingPhone": "8888888888",
    "shippingMobilePhone": "",
    "shippingInstructions": "",
    "shippingAlias": "010721113013",
    "addressType": "home",
    "shippingEmail": "my@home.com",
    "defaultShipping": false
},{
    "beShippingAddressId": 6,
    "shippingAddressName": "Demo 6",
    "shippingAddress1": "Blvd. Benito Juárez 347",
    "shippingAddress2": "",
    "shippingAddress3": "",
    "shippingCity": "Rosarito",
    "shippingCounty": "Villa Turistica",
    "shippingState": "B.C.",
    "shippingPostalCode": "22710",
    "shippingCountry": "MX",
    "shippingPhone": "8888888888",
    "shippingMobilePhone": "",
    "shippingInstructions": "",
    "shippingAlias": "010721113013",
    "addressType": "home",
    "shippingEmail": "my@home.com",
    "defaultShipping": true
}];

export const runConfig = {
    assessmentApp: false,
    language: "en",
    country: "US",
    baseUrl: "https://test.nuskin.com",
    siteConfigurationPath: "https://test.nuskin.com/content/configuration/global/markets/americas",
    id: 371543256621,
    hideSearch: false,
    noSignupMode: false,
    alternateHomeUrl: null
};

export const mrktConfg = {
    enableAddressValidation: true,
    showShipFrom: false,
    mecSite: {
        enableStoredCredentials: true
    },
    checkout: {
        nsurl_sapAdrUpdateService: "https://test.nuskin.com/shop-service/api/v2/adr/:id",
        usecheckoutSideBar: true,
        showPromosInSidebar: true,
        useNewGuestFlow: true,
        enablePickUpPerson: false,
        enableInstallments: true,
        availableCouponsForLocaleUrl: "https://test.nuskin.com/content/localization/offers",
        nsurl_productService: "https://test.nuskin.com/content/products/:sku1/:sku2/:sku3/:sku/:languageCode/_jcr_content.json",
        availableCampaignsForCustomerUrl: "https://test.nuskin.com/account-service/api/v1/campaign",
        clientSecret: "0deea37049e84157A406C0C01D29F300",
        payUMerchantID: "512322",
        showEmailOptIn: false,
        showPaymentPromoCodeOffers: false,
        useDfltShipDayFirst: false,
        useDfltShipDayRecur: false,
        nsurl_sapAdrShipImmediateService: "https://test.nuskin.com/shop-service/api/v2/adr/shipImmediate",
        nsurl_sapOrderService: "https://test.nuskin.com/shop-service/api/v2/order",
        nsurl_shippingService: "https://test.nuskin.com/shop-service/api/v2/shipping/address/:sapId",
        enableLoyalties: false,
        waitingRoomServiceUrl: "http://awstest.nuskin.com/waiting-room/api/customer",
        nsurl_accountService: "/account-service/api/account",
        showShippingPromoCode: false,
        nsurl_availablePaymentTypeService: "https://test.nuskin.com/shop-service/api/v2/payment/typesallowed",
        nsurl_errorMappingService: "https://test.nuskin.com/util-service/api/errormap/:src/:code",
        futureDatesStartNextMonth: false,
        nsurl_sapAdrService: "https://test.nuskin.com/shop-service/api/v2/adr",
        showProductPromoCode: true,
        showWebSavings: true,
        useNewBillingAddress: true,
        postalCodeServiceUrl: "https://awstest.nuskin.com/utility-services/api/postalcode/:cntry/:code",
        showShippingRates: true,
        showContractLengths: false,
        signupAddressFormat: "AddressCountyCityStatePostalCode",
        clientId: "735b1eb810304bba966af0891ab54053",
        hideOrderLeadingZero: false,
        googleMapsApi: "AIzaSyBYw4aJ-Fw7JWFNiiZJAkBl91dPXlvgC3I",
        nsurl_serverRuleValidateService: "https://test.nuskin.com/apps/global/services/validationRule",
        deliveryTimeSlotsServiceUrl: "https://awstest.nuskin.com/qualification-service/api/shippingTimeSlot/available/name/:site",
        showPickupPointsInDropdown: false,
        nsurl_paymentService: "https://test.nuskin.com/shop-service/api/v2/payment/saved/:sapId",
        useVuePaymentSection: false,
        allowSIRecurDateChange: false,
        showPreferredCustomerAccountInfo: true,
        enableBackdating: true,
        showSponsor: true,
        showAccountInfo: true,
        enableCreateAccount: "true",
        enablePayPal: true,
        showPitchPromoCode: true,
        hideShippingMethodPrices: true,
        useQAS: true,
        showShippingMethodPrices: true,
        showAddressCityState: true,
        expandPromoCodeDisplay: true,
        enableGiftReceipt: true,
        showStorefrontPromoCode: true,
        checkForAddress: false,
        hideShippingPostalCode: false,
        shippingAddressFormat: false,
        showSignatureRequired: true
    }
}

export const shippingAddressStrings = {
    add: 'Add',
    addressName: 'Full Name',
    agreeToSaveAddress: 'Save this address to my account',
    cancel: 'Cancel',
    chooseAddressMessage: 'Choose an existing shipping address or add a new one below.',
    continue: 'Continue',
    defaultAddress: 'Default Address',
    delete: 'Delete',
    edit: 'Edit',
    fieldRequired: 'Field Required',
    invalidPhone: 'Invalid phone number',
    instructionsLabel: 'Shipping Instructions',
    market: 'Select Market',
    mobilePhoneLabel: 'Mobile Phone Number',
    phoneLabel: 'Phone Number',
    saveAddress: 'Save Address',
    savedAddresses: 'Saved Addresses',
    setAsDefault: 'Set as default address',
    setDefault: 'Set As Default',
    shippingAddress: 'Shipping Address',
    deleteAddress: 'Delete Address',
    signatureRequired: 'Require a signature on delivery',
    illegalCharacters: 'Invalid characters'
};

export const demoTdcStrings = Object.freeze({
    "processAdrFutureText": "Process my ADR in the future.",
    "preTaxShippingText": "TBD*",
    "usernameLabel": "Username:",
    "orderSubotalDisclaimer": "* Taxes and Shipping will be determined by your shipping address",
    "shippingRatesText": "Shipping rates and delivery times ",
    "countryLabel": "Country:",
    "generalPaymentErrorMessage": "There was a problem with your payment. Please try again.",
    "addText": "Add",
    "currentCartridgeSelection": "Selected Cartridge",
    "editText": "Edit",
    "edit": "Edit",
    "wrPosition": "Your position in the queue is {position} out of {total} ",
    "ccvTipText": "For MasterCard or Visa, it's the last three digits in the signature area on the back of your card. For American Express, it's the four digits on the front of the card.",
    "promotionalCodeSelected": "Promotional Code Selected",
    "ccvMustBeAtLeastThreeDigitsError": "CVV must be at least three digits.",
    "orderPaymentExpiredErrorMessage": "Credit card is expired. Please select a different payment",
    "externalPaymentFailedErrorMessage": "External Payment ",
    "numberAddressFirstError": " ",
    "minimumPurchaseLabel": "Minimum Purchase",
    "mobilePhoneLabel": "Mobile Phone:",
    "ccvLabel": "CVV:",
    "adrOptions": "ADR Options",
    "contactByEmailCheckboxLbl": "by email",
    "adrTncText": "<p>Before you may continue with your application, you must agree to the ADR Terms and Conditions. You may print out the Terms and Conditions for future reference by <a class=\"link1\" onclick=\"window.open(&#39;https://www.nuskin.com/content/dam/eu-library/2019/office/documents/legal/adr-terms-and-conditions/pdf/adr-terms-and-conditions-en-be.pdf&#39;, &#39;_blank&#39;, &#39;location=no&#39;)\">clicking here.</a></p>\n",
    "nameLabel": "Name:",
    "processMyAdrText": "<p>Process my ADR on the following date each month:</p>\n",
    "selectShippingAddressErrorMessage": "Please select a shipping address to continue",
    "adrFirstMessage": "<p>ADR will be processed first then the Order will be processed</p>\n",
    "nextOrderText": "Next Order",
    "failedRetrievingShippingAddresses": "Failed to load shipping addresses",
    "futureContactCheckboxLbl": "I would like to receive commercial communication",
    "adrTncCheckboxText": "I agree to the ADR Terms and Conditions.",
    "savePaymentErrorMessage": "Payment Save Failed ",
    "addPaymentErrorMessage": "Payment Add Failed ",
    "pickupPointsError": "Error loading Pickup Points, please try again. If issues persists, please contact customer care.",
    "add": "Add",
    "couponCodeLabel": "Coupon Code",
    "pickupChooseLocationText": "Choose Location",
    "backToCartText": "Back to Cart",
    "expirationDateMissingErrorMessage": "Expiration Date Missing ",
    "defaultPaymentText": "Default Payment",
    "zeroPsvError": "Oops! This order cannot have a total PSV of zero. ",
    "expLabel": "Exp:",
    "orderPointTotal": "Total points",
    "backdating_electedText": "You have elected to backdate this order to the prior month.",
    "addressTypeText": "Address Type",
    "reviewMessage": "<p>By placing your order, you agree to Nu Skin&#39;s&nbsp;<a href=\"/content/dam/eu-library/Policies%26Procedures/General%20Conditions%20of%20Sale/2016-01%20BE_T%26Cs%20online%20sales_final.pdf\">General Conditions of Sale</a>&nbsp;and&nbsp;<a href=\"/content/dam/eu-library/privacy-policy/nuskin-privacy-policy_EN.pdf\">Privacy Policy</a></p>\n",
    "processAdrTodayText": "Process my ADR today.",
    "installmentDialogTitle": "Terms and Conditions",
    "nextAdrOrderDescriptionText": "Next ADR Order ",
    "selectAdrOptionText": "Please select when your ADR order will be processed:",
    "defaultAddressText": "Default Address",
    "expressShippingLabel": "Express Shipping:",
    "recurringItems": "Recurring Items",
    "shippingMethodLabel": "Shipping Method:",
    "shippingMethodTitle": "Shipping Method",
    "beforePromoCode": "was",
    "nextOrderDescriptionText": "Click next to continue to your next order",
    "pickupLocationLabel": "Pickup Location",
    "hideText": "Hide",
    "orderTotalDisclaimer": "(* plus Taxes and Shipping)",
    "orderDetails": "Order Details",
    "orderSubtotalLabel": "Order Subtotal:",
    "optionalPickupText": "Optional Pickup",
    "shipNowTextSmall": "Ship ADR Today",
    "premiumShippingLabel": "Premium Shipping:",
    "printSaveText": "Print / Save",
    "selectedCode": "Selected Code:",
    "orderFirstMessage": "<p>Order will be processed first then the ADR will be processed</p>\n",
    "returnHomeText": "Return Home",
    "orderConfirmationTitle": "Order Confirmation",
    "sponsorLabel": "Sponsor:",
    "failedRetrievingPaymentsErrorMessage": "Failed Retrieving Payments",
    "otherPaymentMethods": [
        {
            "paymentTypeId": "8",
            "paymentMethodName": "wire",
            "paymentMethodText": "<p>You have chosen <b>Wire</b> as your payment method.</p>\n<p>To complete your payment, please transfer the total invoice amount to the Nu Skin® bank account number below.</p>\n<p>Please always include your order number (9 digit number beginning with 1) in the reference field of your bank transfer otherwise we can\u2019t ensure that your order will be released on time!</p>\n<p><b>Bank holder name:</b>Nu Skin Belgium NV<br>\n<b>Bank account number:</b>230-0992594-13<br>\n<b>IBAN:</b> BE08230099259413<br>\n<b>BICC/Swift:</b>GEBABEBB<br>\n<b>Bank name:</b>BNP Paribas Fortis</p>\n"
        },
        {
            "paymentTypeId": "119",
            "paymentMethodName": "PayPal",
            "paymentMethodText": "You will be transferred after checkout",
            "paymentMethodShortDesc": "summarized text"
        }
    ],
    "paymentMessage":"<p style=\"color: #FF5E00;\"><b>Generic payment message used by Japan</b></p>",
    "pointsBalanceLabel": "Points Balance: ",
    "or": "or",
    "pickUpPersonHeader": "Pickup Person",
    "saveChangesText": "Save Changes",
    "orderCheckoutTitle": "ORDER CHECKOUT",
    "itemsText": "Items",
    "submitButtonText": "Submit",
    "processing": "Processing...",
    "pickUpPersonNumber": "Mobile phone:",
    "expirationDateLabel": "Expiration Date",
    "nextAdrOrderText": "ADR Next Order",
    "promotionalCodeApplied": "Promotion Code has been applied",
    "addressSearchError": "Invalid Searched Address",
    "pickupSelectLocationButton": "Select",
    "referringUplineLabel": "Referring Upline:",
    "nextOrderWarningText": "Next Order",
    "adrNumberLabel": "ADR:",
    "pickupNoPointsFoundText": "There were no pickup points found for this address",
    "shipFromText": "Ship From",
    // "createAccountTermsConditionsPrivayPolicy": "<p>I have read and understand the terms of the <a href=\"/content/nuskin/en_BE/corporate/privacy.html\" target=\"_blank\">privacy notice</a>.</p>\n",
    "recurringShipDayTextSmall": "Monthly ship day: {day}",
    "backdating_changeText": "If you would like to change this order to count for the current month, please",
    "contractLengthSelectLabel": "Please select the length of your contract term:",
    "shipImmediateLabel": "Ship Immediate",
    "failedToSaveShippingAddress": "Failed to save shipping addresses",
    "purchaseQtyWithPoints": "Purchase {qty} items with points",
    "userAlreadyTaken": "That email/username has already been used. Please select another.",
    "shipToThisAddressText": "Ship to this Address",
    "defaultShipLabel": "Default Ship",
    "paymentAgreeMessage": "Do you agree?",
    "addPaymentText": "Add Payment",
    "deleteItemText": "delete item",
    "recurringOrderTextFuture": "Your ADR order will process on the {recurDay} of every month.",
    "userPointsExceededError": "Oops! It looks like you're trying to spend more points than you have available.",
    "firstShipTextSmall": "First ship date: {shipMonth} {shipDay}",
    "yourCoupons": "Your Coupons:",
    "orderCreateFailedErrorMessage": "Your order is being processed. Please check your email for an order confirmation. If you do not receive an email, contact the call center for additional information.",
    "contactBySMSCheckboxLbl": "by SMS",
    "confirmationUserPasswordLbl": "Confirm Password",
    "accountInformationTitle": "Account Information:",
    "continueText": "Continue",
    "quantityLabel": "QTY:",
    "continueToPayPalText": "Continue to PayPal",
    "deleteThisAddress": "Are you sure you want to delete this address?",
    "expiredText": "EXPIRED",
    "fatalErrorHomeLinkTxt": "Home",
    "passwordHintLabel": "Password Hint:",
    "recurringOrderText": "Your ADR order will process on the {recurDay} of every month.",
    "pointTotalPrice": "Total points",
    "payInstallments": "Pay in installments",
    "handlingLabel": "Handling:",
    "pointPrice": "Points",
    "enterAPromotionalCodeLabel": "Enter A Promotional Code:",
    "recurringSubtotalLabel": "Recurring Items Subtotal",
    "emailLabel": "Email:",
    "copyShippingLabel": "Copy Shipping",
    "giftReceiptText": "Gift Receipt",
    "addANewAddress": "Add A New Address",
    "showText": "Show",
    "simulateFailedErrorMessage": "There was a problem calculating your order, please try again. If this problem persists, please contact the call center to place your order.",
    "applyCodeText": "Apply Code",
    "taxTooltipText": "Taxes are calculated on the corresponding value of all items in your cart, including the value of free items.",
    "taxLabel": "VAT:",
    "facilitatorInformation": "Facilitator Information",
    "ccvMustBeANumberError": "CVV must be a number.",
    "failedToAddShippingAddress": "Failed to add shipping addresses",
    "deleteThisPayment": "Are you sure you want to delete this payment?",
    "backOrderedLabel": "Backordered:",
    "distributorIdLabel": "Distributor ID:",
    "delete": "Delete",
    "optionalCompleteSignupText": "Complete Signup",
    "purchaseWithQtyPoints": "Purchase with {qty} points",
    "deliveryTimeSlotText": "Delivery Time Slot ",
    "termsAndConditions": "Do you agree to the price?",
    "purchaseWithPoints": "Purchase this item with points",
    "shipAlwaysLabel": "Ship Always",
    "declinedPaymentErrorMessage": "Your payment was declined. Please try again.",
    "replacement": "Replacement",
    "promotionalCodes": "Promotional Codes",
    "adrCheckoutTitle": "ADR CHECKOUT",
    "available": "Available",
    "pickUpPersonName": "Name:",
    "agreeToAdrUpdateChanges": "I agree to update ADR",
    "scanCardsText": "Scan Cards",
    "newOrderText": "New Order",
    "shippingToLabel": "Shipping To:",
    "shippingAddress": "Shipping Address",
    "youSavedLabel": "You Saved:",
    "usedPointsLabel": "Used Points: ",
    "cancelText": "Cancel",
    "points": "Points",
    "passwordCriteriaLabel": "Your password must be at least 8 characters and meet three of the four criteria: contains a lower case letter, contains an upper case letter, contains a number, or contains a special character.",
    "remove": "Remove",
    "discountLabel": "Discount",
    "postOfficeDeliveryText": "Post Office Delivery",
    "adrTncUrl": "https://www.nuskin.com/content/dam/eu-library/2019/office/documents/legal/adr-terms-and-conditions/html/adr-terms-and-conditions-en-be.html",
    "orderTotalLabel": "Order Total:",
    "addressLabel": "Address:",
    "wrTime": "Your estimated wait time is  {waitTime}",
    "backdating_questionText": "Would you like to backdate this order to the prior month?",
    "orderDateLabel": "Order Date:",
    "changeText": "Change",
    "billingInformation": "Billing Information",
    "recurringOrderTextImmediate": "Your ADR order will process on the {recurDay} of every month.",
    "pickupContactInfoText": "Contact Info",
    "deliveryTimesLabel": "Delivery times (mm/dd time)",
    "promotionalSavings": "Promotional Savings:",
    "adrUpdateFailedErrorMessage": "ADR failed to update.",
    "shippingRatesContent": "<table border=\"0\">\n<tbody><tr><td>Standard Shipping:</td>\n<td>&nbsp;</td>\n</tr><tr><td>Web and ADR orders</td>\n<td>\u20ac 6.65</td>\n</tr><tr><td>Phone/fax/mail</td>\n<td>\u20ac 12.25</td>\n</tr><tr><td>Estimated delivery time (days)<hr>\n\n</td>\n<td>1-3<hr>\n\n</td>\n</tr><tr><td>Express shipping</td>\n<td>\u20ac 38.00</td>\n</tr><tr><td>Estimated delivery time (days)<hr>\n\n</td>\n<td>1<hr>\n\n</td>\n</tr><tr><td>Pick-Up Points UPS Standard<hr>\n\n</td>\n<td>\u20ac 6.65<hr>\n\n</td>\n</tr><tr><td>Free shipping for standard orders above<hr>\n\n</td>\n<td>\u20ac 500.00<hr>\n\n</td>\n</tr></tbody></table>\n<p>The fees shown in this table are excluding VAT. The shipping fees are calculated based on the products in your order.</p>\n",
    "discountCode": "Discount Code:",
    "freeShipping": "Free Shipping",
    "shipFutureTextSmall": "Ship ADR Future",
    "homeDeliveryText": "Home Delivery",
    "placeMyOrderText": "Place My Order",
    "passwordLabel": "Password:",
    "oneTimeItems": "One Time Items",
    "scanCardNumber": "Scan Card Number",
    "useThisCardText": "Use this Payment",
    "installmentDialogCheckBox": "I have read and agreed",
    "reviewOrder": "Review Order",
    "shippingLabel": "Shipping:",
    "pickupFromLocationText": "Pickup from:",
    "firstOrderText": "Your first order will be processed on {shipMonth} {shipDay}.",
    "descriptionLabel": "Description",
    "shipMethodLabel": "Ship Method:",
    "wrInformation": "<div class=\"OutlineElement Ltr SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; overflow: visible; cursor: text; clear: both; position: relative; direction: ltr; font-size: 12px;\"><p class=\"Paragraph SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; word-wrap: break-word; vertical-align: baseline; background-color: transparent; color: windowtext;\"><font face=\"tahoma\"><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-weight: bold; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">You&nbsp;</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-weight: bold; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">h</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-weight: bold; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">ave</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-weight: bold; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\"><span class=\"NormalTextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; background-color: inherit;\">&nbsp;</span></span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-weight: bold; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">b</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-weight: bold; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">een</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-weight: bold; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\"><span class=\"NormalTextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; background-color: inherit;\">&nbsp;</span></span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-weight: bold; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">p</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-weight: bold; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">laced</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-weight: bold; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">&nbsp;in a queue</span><span class=\"EOP SCXW36837747\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px;\">&nbsp;</span></font></p><br></div><div class=\"OutlineElement Ltr SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; overflow: visible; cursor: text; clear: both; position: relative; direction: ltr; font-size: 12px;\"><p class=\"Paragraph SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; word-wrap: break-word; vertical-align: baseline; background-color: transparent; color: windowtext;\"><font face=\"tahoma\"><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">Due\n to the overwhelming response, you have been placed in this virtual \nwaiting room. Your position in the queue, as well as your estimated wait\n time, is displayed below. When you arrive at the front&nbsp;</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">of the queue</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">, you will automatically be redirected into the ordering process.</span><span class=\"EOP SCXW36837747\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px;\">&nbsp;</span></font></p></div><div class=\"OutlineElement Ltr SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; overflow: visible; cursor: text; clear: both; position: relative; direction: ltr; font-size: 12px;\"><p class=\"Paragraph SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; word-wrap: break-word; vertical-align: baseline; background-color: transparent; color: windowtext;\"><font face=\"tahoma\"><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\"><span class=\"NormalTextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; background-color: inherit;\"></span></span><span class=\"EOP SCXW36837747\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px;\">&nbsp;</span></font></p></div><div class=\"OutlineElement Ltr SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; overflow: visible; cursor: text; clear: both; position: relative; direction: ltr; font-size: 12px;\"><p class=\"Paragraph SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; word-wrap: break-word; vertical-align: baseline; background-color: transparent; color: windowtext;\"><font face=\"tahoma\"><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">Please\n note that passing through the waiting room does not guarantee your \nproducts. We strongly recommend you stay by your computer&nbsp;</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">and/or mobile device</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">&nbsp;and be ready to place your order when&nbsp;</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">your turn has come</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">. Entering your order with successful payment is your only guarantee to secure your product</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">(</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">s</span><span class=\"TextRun SCXW36837747\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px; font-variant-ligatures: none !important;\" lang=\"EN-US\">).</span><span class=\"EOP SCXW36837747\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\" style=\"margin: 0px; padding: 0px; user-select: text; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; font-size: 11pt; line-height: 18px;\"> <br></span></font></p></div>",
    "addCouponCode": "Add coupon Code",
    "orderNumberLabel": "Order #:",
    "shippingInformation": "Shipping Address",
    "selectNumInstallments": "Select the number of payments",
    "ccMasking": "ending in",
    "backdating_yesText": "Yes",
    "requiredFieldLabel": "This field is required.",
    "webSavingsText": "You saved {0} by shopping online today.",
    "adrShipImmediateFailedErrorMessage": "ADR Ship Immediate Failed ",
    "expirationDateExpiredErrorMessage": "Expiration Date Expired ",
    "enterAShippingCodeLabel": "Enter A Shipping Code:",
    "cartSectionRedeemPointsButtonTxt": "REDEEM POINTS",
    "outOfStockMessage": "is out of stock and has been removed from your cart.",
    "selectContractLengthText": " {months} months",
    "passwordsDontMatchLbl": "Passwords don't match, please try again.",
    "pickupChangeLocationButton": "Change Location",
    "backdating_backdatedText": "This order has been backdated to the prior month.",
    "additions": "Additions",
    "shipFutureLabel": "Ship Future ",
    "paymentMethodLabel": "Payment Method:",
    "backdating_yesDescriptionText": "If you choose to backdate this order to the prior month, the order volume will count towards the previous commission period.",
    "selectPaymentErrorMessage": "Please select a payment method to continue",
    "backdating_clickHereText": "click here",
    "ccvIsRequiredError": "CVV is required.",
    "scanCardUserName": "Scan Card UserName",
    "createAccountLabel": "Create a new account",
    "standardShippingLabel": "Standard Shipping:",
    "canceledPaymentErrorMessage": "The payment has been canceled.",
    "contractLengthTextSmall": "Contract length: {contractLength}",
    "infoHeadline": "Information",
    "errorHeadline": "Error"
});
